import { send } from 'server';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

export const getBuyInBonus = ({ currencyCode, amount, bonusCode }) => send({
    ID: 32020,
    description: 'Get buy-in bonus',
    responses: [32021, 32022],
    transactionCode: Date.now(),
    transactionDate: getDateForIms(new Date()),
    amount: {
        currencyCode,
        amount
    },
    parameters: [
        {
            key: 'templateCode',
            value: bonusCode
        }
    ]
});
